import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';

const CMEDictionaryAddEditModal = ({ isOpen, handleClose, handleSave, data, type }) => {
    const title = type === 'vaitro' ? 'Vai trò' : 'Đơn vị tính';

    const schema = yup.object().shape({
        ten: yup.string().required(`Vui lòng nhập tên ${title.toLowerCase()}`),
        thuTu: yup.number().nullable()
    });

    return (
        <Modal
            show={isOpen}
            onHide={handleClose}
            centered
            backdrop="static"
            keyboard={false}
            style={{ zIndex: '9999' }}
        >
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title style={{ fontSize: '1.1rem' }}>
                    {data ? 'Cập nhật' : 'Thêm mới'} {title}
                </Modal.Title>
            </Modal.Header>
            <Formik
                validationSchema={schema}
                initialValues={{
                    ten: type === 'vaitro' ? (data?.tenVaiTro || '') : (data?.tenDonViTinh || ''),
                    thuTu: data?.thuTu ?? ''
                }}
                enableReinitialize
                onSubmit={(values) => {
                    if (type === 'vaitro') {
                        handleSave({ tenVaiTro: values.ten, thuTu: values.thuTu });
                    } else {
                        handleSave({ tenDonViTinh: values.ten, thuTu: values.thuTu });
                    }
                }}
            >
                {({ handleSubmit, handleChange, values, errors, touched }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Modal.Body>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Tên {title.toLowerCase()} <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="ten"
                                    value={values.ten}
                                    onChange={handleChange}
                                    isInvalid={touched.ten && !!errors.ten}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.ten}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Thứ tự hiển thị</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="thuTu"
                                    value={values.thuTu}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Đóng
                            </Button>
                            <Button variant="primary" type="submit">
                                Lưu lại
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default CMEDictionaryAddEditModal;
